import { createContext } from "react";

export const routesContext = createContext(null);
